import { Button, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import ModalV2 from '/@/components/bayer/modal-v2';
import { useMutateArchiveCropMonitoringById } from '/@/hooks/crop-monitoring/use-crop-monitoring';
import { _ } from '/@/locale';
import type { CropMonitoring } from '/@/types/crop-monitoring';

const ArchiveCropMonitoringDialog = ({
    cropMonitoring,
    open,
    setClose,
}: {
    cropMonitoring?: CropMonitoring;
    open: boolean;
    setClose: () => void;
}) => {
    const archiveCropMonitoringByIdMutation = useMutateArchiveCropMonitoringById(cropMonitoring);
    const isArchiving = archiveCropMonitoringByIdMutation.isMutating;

    const handleArchive = async () => {
        try {
            await archiveCropMonitoringByIdMutation.trigger();
            setClose();
        } catch {
            enqueueSnackbar(_('Error al finalizar la campaña'), { variant: 'error' });
        }
    };

    return (
        <ModalV2
            open={open}
            onClose={setClose}
            title={_('¿Querés finalizar la campaña?')}
            actions={
                <>
                    <Button variant='text' color='secondary' onClick={setClose} disabled={isArchiving}>
                        {_('Cancelar')}
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={handleArchive}
                        disabled={isArchiving}
                        data-testid='field-monitoring-archive-dialog-confirm-button'
                    >
                        {_('Finalizar campaña')}
                    </Button>
                </>
            }
            actionsProps={{ sx: { justifyContent: 'flex-end' } }}
        >
            <Typography variant='body1' color='primary'>
                {_(
                    'El seguimiento actual pasa a Reportes de campaña y vas a poder empezar uno nuevo. Esta acción no se puede deshacer.'
                )}
            </Typography>
        </ModalV2>
    );
};

export default ArchiveCropMonitoringDialog;
